export enum ProductTag {
    Migration = 'Migration',
    Backup = 'Backup'
}